import type { FilterSchema } from '@which/reviews-filter-definitions'

export const getNeedsBasedFilters = ({ filterSchemas }: { filterSchemas: FilterSchema[] }) =>
  filterSchemas.filter((filterSchema) => filterSchema.externalId === 'needs_based')
